/**
 * 数据字典模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/dict/*
 *
 * 迁移自前端原接口（rest_client.js / odataDict.js / setting_action.js）：
 *   各枚举下拉、状态项、安全群组下拉
 */
import { ofbiz } from './http';

/**
 * 安全群组（角色）下拉（替代旧 /rest/security/safegroup/list）
 *
 * 旧接口返回 { groups: [{Id, Name}] }，新接口返回 { list: [{groupId, groupName, description}] }。
 * 由 action 层做字段映射（groupId→Id, groupName→Name）。
 * @returns {Promise<Array>} [{ groupId, groupName, description }]
 */
export function getSecurityGroups() {
  return ofbiz.post('dict/securityGroups').then(data => {
    // 返回可能是 { list: [...] } 或直接数组，统一成数组
    if (Array.isArray(data)) return data;
    return (data && data.list) || [];
  });
}

/**
 * 枚举批量查询（替代旧各 OData 枚举接口）
 * @param {string|string[]} enumTypeIds 枚举类型 ID，逗号分隔或数组，如 'IT_OPERATION_TYPE,PARTY_STATUS'
 * @returns {Promise<object>} 按类型分组返回 { enumTypeId: [{enumId, description}], ... }
 */
export function getEnums(enumTypeIds) {
  const ids = Array.isArray(enumTypeIds) ? enumTypeIds.join(',') : enumTypeIds;
  return ofbiz.post('dict/enums', null, { enumTypeIds: ids });
}

/**
 * 枚举类型列表
 * @returns {Promise<Array>}
 */
export function getEnumTypes() {
  return ofbiz.post('dict/enumTypes');
}

/**
 * 状态项批量查询
 * @param {string|string[]} statusTypeIds 状态类型 ID，逗号分隔或数组
 * @returns {Promise<object>}
 */
export function getStatuses(statusTypeIds) {
  const ids = Array.isArray(statusTypeIds) ? statusTypeIds.join(',') : statusTypeIds;
  return ofbiz.post('dict/statuses', null, { statusTypeIds: ids });
}
